import { Heart, Instagram, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="relative bg-emerald-darker border-t border-[#C9A86A]/15 py-16 px-6 grain">
    <div className="max-w-6xl mx-auto relative z-10">
      <div className="grid md:grid-cols-3 gap-12 items-start">
        <div>
          <Logo size="sm" />
          <p className="mt-6 font-script text-2xl text-[#F5EFE3]/90 leading-snug">Vaša kosa. Naša umjetnost.</p>
          <p className="mt-2 font-sans tracking-luxury text-[0.65rem] uppercase text-gold/80">Ljepota je u detaljima.</p>
        </div>

        <div className="space-y-4 font-sans text-sm text-[#F5EFE3]/85">
          <div className="flex items-start gap-3">
            <MapPin className="w-4 h-4 text-gold mt-0.5 shrink-0" strokeWidth={1.5} />
            <span>Matije Gupca 6, 31400 Đakovo</span>
          </div>
          <a href="tel:+385916127321" className="flex items-start gap-3 hover:text-gold transition" data-testid="footer-phone">
            <Phone className="w-4 h-4 text-gold mt-0.5 shrink-0" strokeWidth={1.5} />
            <span>091 612 7321</span>
          </a>
          <a
            href="https://instagram.com/lamaison_fp"
            target="_blank"
            rel="noreferrer"
            className="flex items-start gap-3 hover:text-gold transition"
            data-testid="footer-instagram"
          >
            <Instagram className="w-4 h-4 text-gold mt-0.5 shrink-0" strokeWidth={1.5} />
            <span>@lamaison_fp</span>
          </a>
        </div>

        <div className="md:text-right">
          <p className="font-sans tracking-luxury text-[0.65rem] uppercase text-gold/70 mb-3">Radno vrijeme</p>
          <p className="font-sans text-sm text-[#F5EFE3]/85">Pon · Sri · Čet · 13:00 — 20:00</p>
          <p className="font-sans text-sm text-[#F5EFE3]/85">Utorak · 08:00 — 15:00</p>
          <p className="font-sans text-sm text-[#F5EFE3]/85">Petak · 08:00 — 15:00</p>
          <p className="font-sans text-sm text-[#F5EFE3]/85">Subota · 08:00 — 14:00</p>
          <p className="font-sans text-sm text-[#F5EFE3]/60 mt-1">Nedjeljom · zatvoreno</p>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-[#C9A86A]/10 flex flex-col md:flex-row items-center gap-4 justify-center" data-testid="legal-links">
        <Link to="/impressum" className="font-sans tracking-luxury text-[0.6rem] uppercase text-[#F5EFE3]/70 hover:text-gold transition">Impressum</Link>
        <span className="hidden md:inline text-gold/30">·</span>
        <Link to="/pravila-privatnosti" className="font-sans tracking-luxury text-[0.6rem] uppercase text-[#F5EFE3]/70 hover:text-gold transition">Politika privatnosti</Link>
        <span className="hidden md:inline text-gold/30">·</span>
        <Link to="/uvjeti-koristenja" className="font-sans tracking-luxury text-[0.6rem] uppercase text-[#F5EFE3]/70 hover:text-gold transition">Uvjeti korištenja</Link>
        <span className="hidden md:inline text-gold/30">·</span>
        <Link to="/kolacici" className="font-sans tracking-luxury text-[0.6rem] uppercase text-[#F5EFE3]/70 hover:text-gold transition">Kolačići</Link>
        <span className="hidden md:inline text-gold/30">·</span>
        <Link to="/pravila-rezervacije" className="font-sans tracking-luxury text-[0.6rem] uppercase text-[#F5EFE3]/70 hover:text-gold transition">Pravila rezervacije</Link>
      </div>

      <div className="mt-10 pt-6 border-t border-[#C9A86A]/10 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="font-sans text-xs tracking-wide-2 uppercase text-[#F5EFE3]/50">
          Hvala na povjerenju
          <Heart className="inline w-3 h-3 text-gold ml-2" strokeWidth={1.5} />
        </p>
        <p className="font-sans text-[0.65rem] tracking-luxury uppercase text-[#F5EFE3]/40">
          © {new Date().getFullYear()} La Maison by FP
        </p>
      </div>
    </div>
  </footer>
);
